import { render, staticRenderFns } from "./plattaskaccept.vue?vue&type=template&id=f7f877da&"
import script from "./plattaskaccept.vue?vue&type=script&lang=js&"
export * from "./plattaskaccept.vue?vue&type=script&lang=js&"
import style0 from "./plattaskaccept.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports